module.exports = __webpack_public_path__ + "new_name_sharp_left.svg?e5eb4af976ecee97e5cb11334f12bdd8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/new_name_sharp_left.svg
// module id = 184
// module chunks = 0